import { EditAccountWebController } from '../controller/EditAccountWebController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { EditedAccount } from '../types';

export class EditAccountWebComponent extends BaseWebComponentElement {
  public controller!: EditAccountWebController;
  private viewData: EditedAccount;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: EditAccountWebController,
    });
  }

  public setViewData(accountData: EditedAccount): void {
    this.viewData = accountData;
  }

  public getViewData(): EditedAccount {
    return this.viewData;
  }
}
